import React, { useContext, useState, useRef, useEffect } from "react";
import loginimg from "../Assets/Img/loginsideimg.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import axiosMain from "../http/axiosMain";
import { GlobalContext } from "../../utils/GlobalContext";

function SignUpWithOtp() {
  const { isLogdin, setisLogdin, setUserData } = useContext(GlobalContext);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [timer, setTimer] = useState(60); // 60-second countdown
  const [canResend, setCanResend] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const inputsRef = useRef([]);

  // Handle OTP input change
  const handleChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      let newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to next input if a digit is entered
      if (value !== "" && index < otp.length - 1) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  // Handle key events (backspace, delete, and paste)
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        inputsRef.current[index - 1]?.focus();
      }
    } else if (e.key === "Enter") {
      handleSubmit(); // Trigger the OTP submit function
    }
  };

  useEffect(() => {
    if (inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, []);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setCanResend(true); // Allow resending after 30 seconds
    }
  }, [timer]);

  // Handle OTP paste
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pastedData)) {
      setOtp(pastedData.split(""));
      inputsRef.current[5]?.focus(); // Move focus to last input
    }
  };

  // Validate and submit OTP
  const handleSubmit = async () => {
    const otpCode = otp.join("");
    const role = localStorage.getItem("userType");

    if (otpCode.length !== 6) {
      setError("Please enter a valid 6-digit OTP.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await axiosMain.post("/api/auth/verifyEmailOtp", {
        email: id,
        otp: otpCode,
        role: role,
      });

      if (response.data.success || response.status === 200) {
        setisLogdin(true);
        const meResponse = await axiosMain.get("/api/v1/me", {
          withCredentials: true,
        });
        if (meResponse.status === 200) {
          localStorage.setItem("user", JSON.stringify(meResponse.data));
          localStorage.setItem("user_id", meResponse.data.user?.user_id);
          const profileResponse = await axiosMain.get(
            "/api/v1/get-brand-profile"
          );

          if (profileResponse.status === 200 && profileResponse.data?.user) {
            setUserData(profileResponse.data.user); // Update GlobalContext
          }
          const role = meResponse.data?.user?.role;
          if (role) localStorage.setItem("userType", role);

          // const subscriptionRole = role === "brand" ? 1 : 2;
          // const SubscriptionResponse = await axiosMain.get(`/api/subscription/subscription-plan?role_id=${subscriptionRole}`);
          // if (SubscriptionResponse.data.status) {
          //   const allPlans = SubscriptionResponse.data.data;

          //   // Find the plan with type "Starter"
          //   const starterPlan = allPlans.find(plan => plan.plan_type === "Starter");

          //   if (starterPlan) {
          //     const plan_id = starterPlan.razorpay_plan_id;
          //     console.log("llllllllll",plan_id);


          //     // Use this in your subscription call
          //     const subscribeResponse = await axiosMain.post("/api/subscription/subscribe", {
          //       plan_id: plan_id
          //     });

          //   }
          // }
          const plan_id = "free";
          
          // Use this in your subscription call
          const subscribeResponse = await axiosMain.post("/api/subscription/subscribe", {
            plan_id: plan_id
          });

          role === "brand"
            ? navigate("/brand-home", { replace: true })
            : role === "influencer"
              ? navigate("/influencer-home", { replace: true })
              : navigate("/", { replace: true });
        } else {
          setError(meResponse.data?.message || "Failed to fetch user data.");
        }
      } else {
        setError(response.data.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setCanResend(false);
    setTimer(60); // Restart the countdown

    try {
      await axiosMain.post("/api/auth/sendEmailOtp", { email: id });

      // Restart the countdown timer
      const interval = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        "Failed to resend OTP. Please try again."
      );
      setCanResend(true);
    }
  };

  return (
    <div className="container-mobileotp p-0 mt-5 mb-5">
      <div className="card">
        <div className="row no-gutters">
          <div className="col-xs-12 col-sm-12 col-md-12 left">
            <img src={loginimg} alt="Login visual" className="img" />
          </div>

          <div className="col-xs-12 col-sm-12 col-md-12 right">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 text-center">
                <h2>
                  Collaborate.
                  <br /> Create. Connect.
                </h2>

                <div className="otp-input-fields">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      type="tel"
                      className="otp__digit"
                      maxLength={1}
                      value={digit}
                      autoFocus={index === 0}
                      ref={(el) => (inputsRef.current[index] = el)}
                      onChange={(e) => handleChange(index, e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      onPaste={handlePaste}
                    />
                  ))}
                </div>
                {error && <p className="text-danger">{error}</p>}
                <button
                  type="button"
                  className="btn btn-outline-success btn-lg mt-4"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? "Validating..." : "Validate and Log in"}
                </button>

                {/* Resend OTP Section */}
                <div className="mt-3">
                  <button
                    className="btn btn-outline-primary"
                    onClick={handleResendOtp}
                    disabled={!canResend}
                  >
                    {canResend ? "Resend OTP" : `Resend OTP in ${timer}s`}
                  </button>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 footer">
                <Link to="/login" className="btn-link">
                  Log In with Email
                </Link>
                <div className="signup-instruction">
                  By continuing, you agree to our terms and conditions.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUpWithOtp;
